import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import AreaChartDailyPopulation from "./AreaChartDailyPopulation";
import RaikoHostSelectBox from "../../../component/hostSelect/selectBox/RaikoHostSelectBox";

export default function HabitationMonitoringAreaChartDailyPopulationPerHost({periodId, refreshFlag}) {

    const service = new HabitationMonitoringService()

    const [provincePopulationData, setProvincePopulationData] = useState([])
    const [selectedHost, setSelectedHost] = useState(-1)

    function getDataFromServer() {
        service.getHostDailyPopulation(periodId, selectedHost)
            .then(response => {
                setProvincePopulationData([])
                response.items.map((item, index) => {
                    setProvincePopulationData(prev => [
                        ...prev,
                        {
                            name: convertUniversalDateToPersianDate(item.date),
                            value: item.numberOfPeople,
                            capacity: response.capacityOfAcceptation,
                            men: item.numberOfMen,
                            women: item.numberOfWomen,
                        },
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    console.log(typeof periodId !== "undefined" && periodId >= 0 && typeof selectedHost !== 'undefined' && selectedHost !== -1)
    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0 && typeof selectedHost !== 'undefined' && selectedHost !== -1) {
            getDataFromServer()
        }
    }, [periodId, selectedHost]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn className={css`padding-bottom: 1rem;`}>
                <RaikoLabel text={"جمعیت روزانه به تفکیک اقامتگاه"} className={css`height: fit-content;`}/>
                <div className={css`height: 500px;
                    max-height: 500px;
                    display: grid;
                    grid-template-columns: auto 1fr;
                    gap: 1rem;`}>
                    <RaikoHostSelectBox
                        periodId={periodId}
                        isHorizontal={false}
                        setSelectedHost={setSelectedHost}
                        selectedHost={selectedHost}
                    />
                    <div>
                        <AreaChartDailyPopulation
                            dailyPopulationData={provincePopulationData}
                        />
                    </div>
                </div>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}